import "./dashboard-sections.css";
import DashboardCard from "./DashboardCard";
import useTranslator from "../../../hooks/useTranslator";

const DUMMY = {
  actual_paid_kg_case:  "18.5 kg",
  difference_paid_pct:  "3.2%",
  total_prime_pct:      "72.0%",
  real_kg_case:         "17.9 kg",
  real_kg_case_prime:   "12.9 kg",
};

const EvapBox = ({ label, value, isLoading = false }) => (
  <div className="db-evap-box">
    <div className="db-evap-label">{label}</div>
    <div className="db-evap-value neutral">
      {isLoading
        ? <span className="db-shimmer" style={{ height: 24, width: 60, display: "block" }} />
        : (value ?? "—")
      }
    </div>
  </div>
);

const FruitQualityMetrics = ({ data, isLoading = false }) => {
  const { _t } = useTranslator();
  return (
    <DashboardCard title={_t("fruit_quality_metrics", "Fruit Quality Metrics")}>
      <div className="db-evap-row">
        <EvapBox label={_t("actual_paid_w_ripening_waste", "ACTUAL PAID W/ RIPENING WASTE")} value={data?.actual_paid_with_waste_ripening ?? 0} isLoading={isLoading} />
        <EvapBox label={_t("paid_pct_going_into_processing", "PAID % GOING INTO PROCESSING")}  value={data?.prcnt_paid_going_into_processing ?? 0} isLoading={isLoading} />
        <EvapBox label={_t("total_prime_pct", "TOTAL PRIME %")}                 value={data?.total_prime_prcnt ?? 0}     isLoading={isLoading} />
        <EvapBox label={_t("real_kg_case", "REAL KG/CASE")}                  value={data?.real_kg_per_case ?? 0}        isLoading={isLoading} />
        <EvapBox label={_t("real_kg_case_prime", "REAL KG/CASE PRIME")}            value={data?.real_kg_per_case_prime ?? 0}  isLoading={isLoading} />
      </div>
    </DashboardCard>
  );
};

export default FruitQualityMetrics;
